import { render, staticRenderFns } from "./CulturalConcept.vue?vue&type=template&id=9f3d315a&scoped=true&"
import script from "./CulturalConcept.vue?vue&type=script&lang=js&"
export * from "./CulturalConcept.vue?vue&type=script&lang=js&"
import style0 from "./CulturalConcept.vue?vue&type=style&index=0&id=9f3d315a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3d315a",
  null
  
)

export default component.exports